export default __webpack_public_path__ + "static/query-dark-d23fb783862b6f14ab51fad1cee435c4.png";